import React from 'react';

import { IDetailsProps } from '../props';
import { InfoBox, InfoLabel, InfoData } from '../styles';
import Code from '../../../dtos/Code';

interface IProps extends Code {
  companyId: number;
  value: string;
  dynamic: string;
  observation: string;
  isBlocked: string;
  volume: string;
  partition: string;
  stackingLimit: string;
  warning: string;
  product?: string;
  onuNumber?: string;
  usefulInformation?: string;
}

const fields: { key: keyof IProps; label: string }[] = [
  { key: 'product',           label: 'Produto' },
  { key: 'isBlocked',         label: 'Status' },
  { key: 'observation',       label: 'Observação' },
  { key: 'volume',            label: 'Volume' },
  { key: 'partition',         label: 'Partição' },
  { key: 'stackingLimit',     label: 'Limite de empilhamento' },
  { key: 'onuNumber',         label: 'Número ONU' },
  { key: 'warning',           label: 'Aviso de perigo' },
  { key: 'usefulInformation', label: 'Informações úteis' },
];

const ImbelData: React.FC<IDetailsProps<IProps>> = ({ data }) => (
  <>
    {fields.map(({ key, label }) =>
      data?.[key] ? (
        <InfoBox key={key}>
          <InfoLabel>{label}</InfoLabel>
          <InfoData>{data[key] as string}</InfoData>
        </InfoBox>
      ) : null
    )}
  </>
);

export default ImbelData;
